import { Location } from "@angular/common";
import { HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    Resolve,
    RouterStateSnapshot,
} from "@angular/router";
import { ApiGateway, OrderPay, PageOptions } from "cw-backend";
import { CwUtils } from "cw-utils";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable()
export class OrderPayListProvider implements Resolve<any> {
    orderPay: OrderPay[];
    orderPayEdit: OrderPay;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(public gw: ApiGateway, private location: Location) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        this.currentPage = this.state?.currentPage;
        this.orderPayEdit = this.state?.currentOrderPay;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
        } else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = "date";
        }
        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getPage(this.pageOptions)]).then(() => {
                resolve();
            }, reject);
        });
    }

    get(id: number): Observable<OrderPay> {
        if (!id) {
            return null;
        }
        return this.gw.get("orderPay/:id", { id: id });
    }

    get currentOrderPay(): OrderPay {
        return this.orderPayEdit;
    }

    getAll(orderId: number, pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .get(`order/pays/${orderId}`, pageOptions)
                .subscribe((res: HttpResponse<any>) => {
                    this.orderPay = res.body;
                    resolve(res);
                }, reject);
        });
    }

    getAllByBudget(budgetId: number, pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .get(`order/paysByProtocol/${budgetId}`, pageOptions)
                .subscribe((res: HttpResponse<any>) => {
                    this.orderPay = res.body;
                    resolve(res);
                }, reject);
        });
    }

    getPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post("orderPay/search", pageOptions)
                .subscribe((res: HttpResponse<any>) => {
                    if (
                        !CwUtils.compare(this.orderPay, res.body.content) &&
                        res.body.content.length > 0
                    ) {
                        this.orderPay = res.body.content;
                        this.onDataChanged.next(this.orderPay);
                    } else {
                        this.orderPay = res.body.content;
                    }
                    resolve(res);
                }, reject);
        });
    }

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }

    getOrderPayMissing(id: number) {
        return new Promise((resolve, reject) => {
            this.gw
                .get(`order/orderPayMissingValue/${id}`)
                .subscribe((res: HttpResponse<any>) => {
                    resolve(res);
                }, reject);
        });
    }

        getOrderPayMissingWithDiscountParticular(id: number) {
        return new Promise((resolve, reject) => {
            this.gw
                .get(`order/missing-value-discount-private/${id}`)
                .subscribe((res: HttpResponse<any>) => {
                    resolve(res);
                }, reject);
        });
    }
}
